/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */

require(["common"], function(){
    require(["jquery"], function($) {
        $(document).ready(function(){
            $('#eventFilters input[type=checkbox], #eventFilters select')
                .on('change', function(){
                    $('#eventFilters').submit();
                });
        });
    });
});
define("events", function(){});

